import {Component, inject, Input} from '@angular/core';
import {map, tap} from 'rxjs';
import {
    GetOrderPlanningMixScoreQuery,
    GetPostProductionMdtScoreQuery,
    GetPreProductionOrdersScoreQuery,
    IMyScoreShiftQuery,
    OrdersClient,
    ScoreDto,
} from '@services';
import {DoughnutChartComponent} from '../../../components/library/doughnut-chart/doughnut-chart.component';
import {CardItem} from '../../attendance/my-score/summary-card/summary-card.component';
import {orderPlanningMixPalette} from '../../outbound/my-score/order-planning-mix/order-planning-mix.component';
import {postProductionCenterText, postProductionMdtPalette} from '../../outbound/my-score/post-production-mdt/post-production-mdt.component';
import {preProductionOrdersPalette, preProductionSummaryTiles} from '../../outbound/my-score/pre-production-orders/pre-production-orders.component';
import {DashboardAccess} from '../dashboard-access';
import {DashboardCardComponent} from '../dashboard-card/dashboard-card.component';
import {DashboardTilesComponent} from '../dashboard-tiles/dashboard-tiles.component';

@Component({
    selector: 'app-dashboard-outbound',
    imports: [DoughnutChartComponent, DashboardCardComponent, DashboardTilesComponent],
    templateUrl: './dashboard-outbound.component.html',
})
export class DashboardOutboundComponent {
    @Input() from: Date;
    @Input() to: Date;

    protected access = inject(DashboardAccess);
    private ordersClient = inject(OrdersClient);

    protected readonly palettes = {
        orderPlanningMix: orderPlanningMixPalette(),
        postProductionMdt: postProductionMdtPalette(),
        preProductionOrders: preProductionOrdersPalette(),
    };

    protected preProductionTiles: CardItem[] = [];

    protected loadOrderPlanningMix = (query: IMyScoreShiftQuery) =>
        this.ordersClient
            .getOrderPlanningMixScore(new GetOrderPlanningMixScoreQuery(this.allDay(query)))
            .pipe(map(dto => new ScoreDto({avgScorePercent: dto.myScorePercent, totals: dto.totals})));

    protected loadPostProductionMdt = (query: IMyScoreShiftQuery) =>
        this.ordersClient
            .getPostProductionMdtScore(new GetPostProductionMdtScoreQuery(this.allDay(query)))
            .pipe(map(dto => new ScoreDto({avgScorePercent: dto.totalLoads, totals: dto.totals})));

    protected loadPreProductionOrders = (query: IMyScoreShiftQuery) =>
        this.ordersClient
            .getPreProductionOrdersScore(new GetPreProductionOrdersScoreQuery(this.allDay(query)))
            .pipe(
                tap(dto => this.preProductionTiles = preProductionSummaryTiles(dto)),
                map(dto => new ScoreDto({avgScorePercent: dto.myScorePercent, totals: dto.totals})),
            );

    protected get postProductionCenterText(): string {
        return postProductionCenterText(this.from, this.to);
    }

    private allDay(query: IMyScoreShiftQuery) {
        return {from: query.from, to: query.to, fromHour: 0, toHour: 24};
    }
}
